import React from 'react';
import ReactDOM from 'react-dom';

import type { Initializer } from 'common/types/initializers';
import { Reconnect } from 'src/federation/Reconnect';

type ClientItemFromSearch = {
  emailAddress?: string;
  id: number;
  name: string;
  phone?: string;
  prepaymentRequired?: boolean;
};

function mapToHeaderSearchClients(
  clientItems: ClientItemFromSearch[],
): Array<{
  emailAddress?: string;
  id: number;
  name: string;
  phone?: string;
  prepaymentRequired?: boolean;
}> {
  return clientItems.map((item) => ({
    emailAddress: item.emailAddress,
    id: item.id,
    name: item.name,
    phone: item.phone,
    prepaymentRequired: item.prepaymentRequired,
  }));
}

export const HeaderSearchClientResultsInitializer = ({
  clientItems,
  containerNode,
  onCloseDropdown,
  onMounted,
}: {
  clientItems: ClientItemFromSearch[];
  containerNode: HTMLElement;
  onCloseDropdown: () => void;
  onMounted?: () => void;
}): Initializer => {
  const clients = mapToHeaderSearchClients(clientItems);

  const onOpenProfile = (clientId: number) => {
    onCloseDropdown();
    App.ES6.Initializers.ClientOverview({
      accessedFrom: 'header_search',
      clientId,
      onClose: () => {},
    }).render();
  };

  const onOpenAppointments = (clientId: number) => {
    onCloseDropdown();
    App.ES6.Initializers.ClientOverview({
      accessedFrom: 'header_search',
      clientId,
      initialScreen: 'appointments',
      onClose: () => {},
    }).render();
  };

  return {
    destroy: () => {
      ReactDOM.unmountComponentAtNode(containerNode);
    },
    render: () => {
      ReactDOM.render(
        <Reconnect
          name="HeaderSearchClientResults"
          props={{
            clients,
            containerNode,
            onMounted,
            onOpenAppointments,
            onOpenProfile,
          }}
        />,
        containerNode,
      );
    },
  };
};
